<template>
  <div>
    <Header :isCollapse="isCollapse" @toggleCollapse="toggleCollapse"></Header>
    <div class="main">
      <Sider :collapse="isCollapse"></Sider>
      <div class="container">
        <div class="breadcrumb">
          <Breadcrumb />
        </div>
        <!-- <div class="tagViews">
          <TagViews />
        </div> -->
        <div class="content">
          <router-view :key="key" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./components/Header";
import Sider from "./components/Sider";
import Breadcrumb from "./components/breadcrumb";
import TagViews from "./components/tagViews.vue";
export default {
  name: "Layout",
  props: {},
  components: {
    Header,
    Sider,
    Breadcrumb,
    TagViews,
  },
  computed: {
    key() {
      return this.$route.path;
    },
  },
  data() {
    return {
      isCollapse: false,
    };
  },
  methods: {
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
  },
};
</script>


<style lang="scss" scoped>
.main {
  height: calc(100vh - 62px);
  display: flex;
  .container {
    overflow-x: auto;
    overflow-y: auto;
    flex: 1;
    min-height: calc(100vh - 58px - 40px);
    background-color: #f7f9fb;
    .content {
      width: 100%;
      padding-top: 40px;
      height: calc(100vh - 62px - 40px);
    }
  }
}
</style>